module.exports = __webpack_public_path__ + "static/media/banner_img.07ec6a8a.svg";